export const genders = [
    { title: 'Muž', value: 'M' },
    { title: 'Žena', value: 'F' }
  ];
  